import { useCallback } from 'react';
import { useReactFlow } from '@xyflow/react';
import i18n from '../../../i18n';

export function useNodeClick(nodeId: string) {
  const { setNodes, setEdges, getNode } = useReactFlow();

  return useCallback(() => {
    const parent = getNode(nodeId);
    if (!parent) return;
    // 자식 노드 추가 (간단 예시)
    setNodes((nds) => [
      ...nds,
      {
        id: `${nodeId}-child-${Math.random().toString(36).slice(2, 8)}`,
        type: 'workflow',
        position: { x: parent.position.x + 200, y: parent.position.y + 150 },
        data: { label: i18n.t('workflow:node.new') },
        parentId: nodeId,
      },
    ]);
    // 실제로는 setEdges로 연결도 추가해야 함
  }, [getNode, nodeId, setNodes]);
} 